import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "originInput", "collectionInput" ]

  get originWrapperTarget() {
    return this.originInputTarget.closest(".mdl-textfield")
  }

  connect() {
    const collectionId = this.collectionInputTarget.value;
    if (!collectionId) return;

    const savedOriginId = this.originInputTarget.dataset.selectedOriginId;
    const url = new URL(this.originInputTarget.dataset.url);
    url.searchParams.set("certification_collection_id", collectionId);

    fetch(url)
      .then(response => response.json())
      .then(origins => {
        this.enableOrigin(origins);
        if (savedOriginId) {
          this.originInputTarget.value = savedOriginId;
        }
      })
      .catch(() => {});
  }

  onCollectionChanged(event) {
    this.disableOrigin();

    let certificationCollectionId = event.target.value;

    if (certificationCollectionId != "") {
      let originsURL = new URL(this.originInputTarget.dataset.url);
      originsURL.searchParams.set("certification_collection_id", certificationCollectionId)

      fetch(originsURL)
        .then(response => response.json())
        .then(origins => {
          this.enableOrigin(origins);
        })
        .catch(() => this.disableOrigin());
    }
  }

  clearOrigins() {
    this.originInputTarget.innerHTML = "";
  }

  disableOrigin() {
    this.clearOrigins();

    this.originWrapperTarget.classList.add("disabled");
    this.originWrapperTarget.classList.add("is-disabled");
    this.originWrapperTarget.classList.remove("is-dirty");
    this.originInputTarget.disabled = true;
    this.originInputTarget.classList.add("disabled");
  }

  enableOrigin(origins) {
    let select = this.originInputTarget;
    let wrapper = this.originWrapperTarget;

    select.disabled = false;
    select.classList.remove("disabled");
    wrapper.classList.remove("disabled");
    wrapper.classList.remove("is-disabled");
    wrapper.classList.add("is-dirty");

    this.clearOrigins();

    select.options[0] = new Option("", "");

    origins.forEach(origin => {
      select.options[select.options.length] = new Option(origin.label, origin.id);
    });
  }
}
